/* eslint-disable no-unused-vars */
import {
	gridPageCountSelector,
	gridPageSelector,
	gridPageSizeSelector,
	gridPaginationMetaSelector,
	gridPaginationModelSelector,
	gridPaginationRowCountSelector,
	gridPaginationRowRangeSelector,
	useGridApiContext,
	useGridSelector,
} from '@mui/x-data-grid';
import { MenuItem, Pagination, PaginationItem, Select } from '@mui/material';
import usePagination from '@mui/material/usePagination/usePagination';
import { twMerge } from 'tailwind-merge';
import { useState } from 'react';

const labels = {
	previous: 'Forrige',
	next: 'Neste',
};

const Previous = () => {
	return <button>Forrige</button>;
};

export default function CustomPagination(props) {
	const apiRef = useGridApiContext();
	const page = useGridSelector(apiRef, gridPageSelector);
	const pageCount = useGridSelector(apiRef, gridPageCountSelector);
	const pageSize = useGridSelector(apiRef, gridPageSizeSelector);
	const rowCount = useGridSelector(apiRef, gridPaginationRowCountSelector);

	const [currPage, setCurrPage] = useState(page);

	// const p = usePagination({
	// 	count: pageCount,
	// });

	const total = (page + 1) * pageSize;
	return (
		<div className='flex justify-between w-full pl-4'>
			<div className='flex items-center justify-center gap-4'>
				<div className='flex items-center justify-center gap-2'>
					Viser
					<Select
						displayEmpty
						labelId='payment-type-label'
						id='payment-type'
						className='h-8 w-18'
						value={pageSize}
						onChange={(e) => apiRef.current.setPageSize(+e.target.value)}
						placeholder=''
						size='small'
					>
						{[10, 20, 50, 100]?.map((p) => (
							<MenuItem key={p} value={p} name={p}>
								{p}
							</MenuItem>
						))}
					</Select>
					rader
				</div>
				<div className='flex items-center justify-center gap-1'>
					Viser {page * pageSize} to {total > rowCount ? rowCount : total} of {rowCount} rader
				</div>
			</div>

			{/* <div className='flex gap-1'>
				{p.items.map(({ page, type, selected, ...item }, index) => {
					let children = null;

					if (type === 'start-ellipsis' || type === 'end-ellipsis') {
						children = <span className='flex items-center h-10'>…</span>;
					} else if (type === 'page') {
						children = (
							<button
								type='button'
								className={twMerge(
									'flex items-center justify-center w-auto h-10 border rounded-sm min-w-10',
									currPage === page - 1 ? 'font-bold bg-bd-blue text-white' : ''
								)}
								{...item}
								onClick={() => {
									apiRef.current.setPage(page - 1);
									setCurrPage(page - 1);
									// apiRef.current.jumpToPage(page - 1);
								}}
							>
								{page}
							</button>
						);
					} else {
						children = (
							<button
								type='button'
								{...item}
								className='flex items-center h-10'
								onClick={() => {
									if (type === 'next') {
										apiRef.current.setPage(currPage + 1);
										setCurrPage(currPage + 1);
									} else if (type === 'previous') {
										apiRef.current.setPage(currPage - 1);
										setCurrPage(currPage - 1);
									}
								}}
							>
								{type in labels ? labels[type] : type}
							</button>
						);
					}

					return (
						<div className='' key={index}>
							{children}
						</div>
					);
				})}
			</div> */}
			<Pagination
				className='bz-pagination'
				variant='outlined'
				shape='rounded'
				page={props.page ? props.page + 1 : page + 1}
				count={props.count ? Math.round(props.count / pageSize) : pageCount}
				// count={Math.round(props.count / pageSize)}
				renderItem={(props2) => <PaginationItem {...props2} disableRipple />}
				onChange={(_, value) => {
					apiRef.current.setPage(value - 1);
					// if (props.onChange && typeof props.onChange === 'function') {
					// 	props.onChange(_, value);
					// }
				}}
				// slot={{ previous: Previous }}
				// slotProps={{
				// 	previous: {},
				// }}
			/>
		</div>
	);
}
